import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-account-order-details-page',
  templateUrl: './account-order-details-page.component.html',
  styleUrls: ['./account-order-details-page.component.css']
})
export class AccountOrderDetailsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
   $('#initialise-page').trigger('click');
  }

}
